import { SUPPORTED_LOCALES } from '../locales';
import { CATALOG_PATH_SEGMENTS } from './catalog-path-segments';

export function isCatalogPath(pathname: string): boolean {
  if (!pathname.startsWith('/')) {
    return false;
  }
  const segments = pathname.split('/').filter((segment) => segment.length > 0);
  const [first, second] = segments;
  if (!first) {
    return false;
  }
  const candidate = SUPPORTED_LOCALES.includes(first as (typeof SUPPORTED_LOCALES)[number])
    ? second
    : first;
  if (!candidate) {
    return false;
  }
  const withoutQuery = candidate.split(/[?#]/)[0];
  return CATALOG_PATH_SEGMENTS.includes(withoutQuery as (typeof CATALOG_PATH_SEGMENTS)[number]);
}
